import styled from '@xstyled/styled-components';
import { Card } from '~/ui/card/Card';

export const OnboardingCard = styled(Card)`
  transform-origin: 30% bottom;
  width: 240px;
  height: 350px;
  border-radius: xl;
`;
